import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CustomMonthPicker = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder = "Select Month",
  allowClear = true,
  showToday = true,
  size = "middle",
  error,
  touched,
  className = "",
  disableFuture = false,
  disablePast = false,
  ...props
}) => {

  // const disabledDate = (current) => {
  //     return disableFuture && current && current.isAfter(dayjs(), "day");
  // };
  const disabledDate = (current) => {
    if (!current) return false;

    // disable future months
    if (disableFuture && current.isAfter(dayjs(), "month")) {
      return true;
    }

    // disable previous months
    if (disablePast && current.isBefore(dayjs(), "month")) {
      return true;
    }
    return false;
  };

  return (
    <DatePicker
      picker="month"                            // ✅ Show only Month & Year
      format="MMM/YYYY"                         // ✅ Format like Jan/2025
      value={value ? dayjs(value) : null}
      onChange={(date) =>
        onChange(date ? dayjs(date).format("YYYY-MM-DD") : null)
      }
      onBlur={(e) => onBlur({ target: { name } })}
      name={name}
      style={{ width: "100%" }}
      placeholder={placeholder || "Select Month and Year"}
      allowClear={allowClear}
      disabledDate={disabledDate}
      showToday={false}
      size={size}
      // defaultPickerValue={dayjs("2026-01", "YYYY-MM")} // ✅ Set default to Jan 2025
      defaultPickerValue={dayjs()}
      {...props}
    />
  );
};

export default CustomMonthPicker;
